import React from "react";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_ORTU } from "@/lib/nav";
import KalenderPendidikan from "@/components/KalenderPendidikan";

export default function KalenderPendidikanOrtu() {
  return (
    <Layout nav={NAV_ORTU}>
      <PageTitle title="Kalender Pendidikan" />
      <KalenderPendidikan />
    </Layout>
  );
}
